import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import Text from 'theme/Text'
import { useIsFocused } from "@react-navigation/native";
import { useSelector } from "react-redux";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import _ from "lodash"
import ThemedBlock from "components/atoms/ThemedBlock";
import { ThemedShared } from "styles/themed";
import { settingsConstants } from "utils/constants/settings-constants";
import HelperSetting from "utils/helper-setting";
import GraphqlBuilder from "utils/request/graphql/builder";
import { colorList } from "utils/colors";
import { Grid } from 'components/atoms/BootstrapGrid'
import HelperPlatform from "utils/helper-platform";
import ObjectEmployee from 'utils/objects/employee'
import { dataConstants } from 'services/redux/data/constants'
import { useShowHamburger } from 'utils/helper-device'
import HelperString from 'utils/helper-string'
import FetchQrCode from 'utils/fetch/FetchQrCode'
import MutationManagementQrCode from 'graphql/mutations/management/MutationManagementQrCode'
import ThemedDivider from 'components/atoms/ThemedDivider'
import Form from 'components/molecules/Form'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants';
import LoadingComponent from 'components/atoms/Loading'
import ThemedModal from 'components/atoms/ThemedModal'
import ThemedPressable from 'components/atoms/ThemedPressable'
import { qrcodeConstants } from 'utils/constants/qrcode-constants'
import ThemedQrCode from 'components/atoms/ThemedQrCode'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Popover from 'theme/Popover'
import Card from 'theme/Card'
import Spinner from "theme/Spinner";
import Button from "theme/Button";
import MutationManagementQrCodeUpdate from 'graphql/mutations/management/MutationManagementQrCodeUpdate'
import { constantsActive } from 'utils/constants/constants'
import { configClient } from 'components/provider/ConfigProvider'
import { openUrl } from 'utils/helper-url'
import VStack from 'components/atoms/stack/VStack'
import { ThemedValues } from 'styles/themed'
import HelperArray from 'utils/helper-array'

const ManagementQrcodeIndexScene = () => {

	const isFocused = useIsFocused();
	const showHamburger = useShowHamburger();

	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )

	const _buildings        = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} );
	const _floors           = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} );
	const _rooms            = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} );
	const _timeslotKinds    = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	const _timeslotGroups = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_GROUPS];
	} );

	const [ selectedOptions, setSelectedOptions ] = useState( {} );
	const [ selectBuildingOptions, setSelectBuildingOptions ] = useState( [] );
	const [ selectFloorOptions, setSelectFloorOptions ] = useState( [] );
	const [ selectRoomOptions, setSelectRoomOptions ] = useState( [] );
	const [ selectTimeslotGroupOptions, setSelectTimeslotGroupOptions ] = useState( [] );
	const [ selectTimeSlotKindOptions, setSelectTimeSlotKindOptions ] = useState( [] );

	const [ qrCodesLoading, setQrCodesLoading ] = useState( false );
	const [ qrCodes, setQrCodes ] = useState( [] );

	const isOndmand = ObjectEmployee.isOndmand( _employee );

	const fetchQrCodes = () => {
		if( qrCodesLoading ) return;

		FetchQrCode.fetchAll({
			callbackStart: () => {
				setQrCodesLoading( true );
			},
			callbackError: () => {
				setQrCodesLoading( false );
			},
			callbackSuccess( {qrcodes} ) {
				setQrCodes( qrcodes );
				setQrCodesLoading( false );
			},
		})
	}

	const generateQrCode = ( values, { callback } = {}  ) => {
		values = {
			data: JSON.stringify( selectedOptions )
		};

		new GraphqlBuilder( { processVariables: false })
			.addQuery( 'mutation_qrode', MutationManagementQrCode, values )
			.setResultPath( ['mutation', 'mutation_qrode'], {} )
			.setOnStart( callback.bind( this, FormStatus.LOADING ) )
			.setOnError( callback.bind( this, FormStatus.ERROR ) )
			.setOnSuccess( ( result ) => {
				fetchQrCodes();
				callback( FormStatus.SUCCESS );
			})
			.execute()
	}

	const formChanged = ( values ) => {
		// Remove empty timeslotKinds
		if( values?.timeslotKind !== undefined ){
			values.timeslotKind = _.pickBy( values.timeslotKind, ( value ) => {
				return !_.isEmpty( value );
			} );
		}

		//remove empty values
		values = _.pickBy( values, ( value ) => {
			return !_.isEmpty( value );
		} );


		setSelectedOptions( {...values} );
	}

	const retrieveTimeslotKinds = ( timeslotKinds, timeslots ) => {
		_.forEach( timeslots, ( timeslot ) => {
			let identifier = `${timeslot?.kind}_${timeslot?.sub_kind}`;
			if( !_.includes( timeslotKinds, identifier ) ) {
				timeslotKinds.push( identifier );
			}
		});

		return timeslotKinds;
	}

	useEffect( () => {
		let buildingOptions = [];
		let floorOptions = [];
		let roomOptions = [];
		let timeslotKinds = [];

		_.forEach( _buildings, ( o ) => {
			buildingOptions.push( {
				value: o.guid,
				label: o.name + " ("+ i18n.t(`management:generic.active.${o.active}`) +")",
			});
		});

		if( selectedOptions?.building !== null ) {
			timeslotKinds = retrieveTimeslotKinds( timeslotKinds, _.get( _buildings, [ selectedOptions?.building, 'timeslots_through' ], [] ) );

			_.forEach( _.get( _buildings, [ selectedOptions?.building, 'floors' ], [] ), ( floor ) => {
				floor = _.get( _floors, floor.guid, null );

				if( _.isEmpty( selectedOptions?.floor ) ){
					timeslotKinds = retrieveTimeslotKinds( timeslotKinds, _.get( floor, 'timeslots_through', [] ) );
				}

				if( floor ) {
					floorOptions.push( {
						value: floor.guid,
						label: floor.name,
					} )
				}
			});
		}

		if( !_.isEmpty( selectedOptions?.floor ) ) {
			timeslotKinds = retrieveTimeslotKinds( timeslotKinds, _.get( _floors, [ selectedOptions?.floor, 'timeslots_through' ] , [] ) );

			_.forEach( _.get( _floors, [ selectedOptions?.floor, 'rooms' ], [] ), ( room ) => {
				room = _.get( _rooms, room.guid, null );
				if( room ) {
					roomOptions.push( {
						value: room.guid,
						label: room.name,
					} )
				}
			});
		}

		if( !_.isEmpty( selectedOptions?.room ) ){
			timeslotKinds = retrieveTimeslotKinds( timeslotKinds, _.get( _rooms, [ selectedOptions?.room, 'timeslots_through' ] , [] ) );
		}

		let selectTimeslotKinds = [];
		if( timeslotKinds.length > 0 ){
			_.forEach( timeslotKinds, ( timeslotKind ) => {
				timeslotKind = _.get( _timeslotKinds, [ timeslotKind ], [] );
				selectTimeslotKinds.push( {
					value: timeslotKind.guid,
					label: timeslotKind.name,
				} )
			})
		}

		// this is currently already 'dynamic' because we might want to change the amount of options based on above in the future
		let selectTimeslotGroups = [];
		if( _.size( _timeslotGroups ) > 0 ){
			_.forEach( _timeslotGroups, ( timeslotGroups ) => {
				selectTimeslotGroups.push( {
					value: timeslotGroups.guid,
					label: timeslotGroups.name,
				} )
			});
		}

		setSelectRoomOptions( roomOptions );
		setSelectBuildingOptions( buildingOptions );
		setSelectFloorOptions( floorOptions );
		setSelectTimeSlotKindOptions( selectTimeslotKinds );
		setSelectTimeslotGroupOptions( selectTimeslotGroups );

	}, [ _buildings, _floors, _rooms, _timeslotKinds, selectedOptions ] );

	useEffect(() => {
		if( isFocused ) {
			fetchQrCodes();
		}
	}, [ isFocused ] )

	let settingValues = {}
	_.forEach( settingsConstants, ( settingString ) => {
		settingValues[ settingString ] = HelperSetting.get( settingString );
	});

	const scanOptions = [
		{ value: qrcodeConstants.SCANIN, label:  i18n.t( `management:constants.scanin` ) },
		{ value: qrcodeConstants.BOOK, label: i18n.t( `management:constants.book`) }
	];

	let formFields = [
		{
			label: i18n.t( 'management:form.scan_option.title' ),
			name: 'scanOption',
			type: FormFieldsConstants.SELECT,
			placeholder: i18n.t( 'management:ui.choose' ),
			options: scanOptions
		}
	];

	if( selectBuildingOptions.length > 0 ){
		formFields.push({
			label: i18n.t( 'management:form.building.title' ),
			name: 'building',
			type: FormFieldsConstants.SELECT,
			placeholder: i18n.t( 'management:form.building.choose' ),
			options: selectBuildingOptions
		});
	}

	if( selectFloorOptions.length > 0 ){
		formFields.push({
			label: i18n.t( 'management:form.floor.title' ),
			name: 'floor',
			type: FormFieldsConstants.SELECT,
			placeholder: i18n.t( 'management:form.floor.all' ),
			options: selectFloorOptions
		});
	}

	if( selectRoomOptions.length > 0 ){
		formFields.push({
			label: i18n.t( 'management:form.room.title' ),
			name: 'room',
			type: FormFieldsConstants.SELECT,
			placeholder: i18n.t( 'management:form.room.all' ),
			options: selectRoomOptions
		});
	}

	formFields.push({
		label: i18n.t( 'management:form.timeslot_group.title' ),
		name: 'timeslotGroup',
		type: FormFieldsConstants.SELECT,
		placeholder: i18n.t( 'management:form.timeslot_group.all' ),
		options: selectTimeslotGroupOptions
	});

	if( selectedOptions?.scanOption === qrcodeConstants.BOOK  ) {
		formFields.push({
			label: i18n.t( 'management:form.preview_timeslots.title' ),
			name: 'previewTimeslots',
			type: FormFieldsConstants.SELECT_ACTIVE
		});
	}

	if( selectTimeSlotKindOptions.length > 0){
		formFields.push({
			label: i18n.t( 'management:form.timeslot_kinds.title' ),
			hint: i18n.t( 'management:form.timeslot_kinds.hint' ),
			name: 'timeslotKind',
			type: FormFieldsConstants.SELECT_MULTI,
			options: selectTimeSlotKindOptions
		});
	}

	let submitDisabled = selectedOptions?.scanOption === undefined || selectedOptions?.building === undefined;
	if( selectedOptions?.scanOption === qrcodeConstants.BOOK && selectedOptions?.timeslotGroup === undefined ){
		submitDisabled = true
	}

	// Render
	let content = <LoadingComponent />;

	if ( qrCodes.length > 0 ) {
		content = [];

		_.forEach( [ qrcodeConstants.SCANIN, qrcodeConstants.BOOK ], ( qrCodeScanOption ) => {
			const qrCodeList = [];
			_.forEach( qrCodes, ( qrCode ) => {

				// Filter
				const data = JSON.parse( qrCode.data );

				// Skip
				if( _.get( data, 'scanOption' ) !== qrCodeScanOption ) {
					return true;
				}

				//
				if( qrCodeList.length > 0 ){
					qrCodeList.push(
						<ThemedDivider
							style={ styles.themedDividerMarginVertical12 }
						/>
					);
				}

				qrCodeList.push(
					<QrRow
				        qrCode={ qrCode }
						details={ isOndmand }
						refetch={ fetchQrCodes }
					/>
				);
			});

			if( qrCodeList.length > 0 ) {
				content.push(
					<ThemedBlock
						key={ HelperString.hash( 'qr-code-list', qrCodeScanOption ) }
						mediumPadding
						shadow
						header={ i18n.t( `management:constants.${qrCodeScanOption}`)}>

						<Grid>
							{ qrCodeList }
						</Grid>
					</ThemedBlock>
				);
			}
		});
	}

	return (
		<ThemedSafeAreaComponentTop
			top={ false }>

			<ThemedLayout
				title={ i18n.t('management:pages.qrcodes.index.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					<ThemedBlock
						mediumPadding
						shadow>
	
						<Form
							key={ HelperString.hash( 'form' ) }
							values={{
								scanOption: qrcodeConstants.SCANIN
							}}
							fields={ formFields }
							onChange={ formChanged }
							onSubmit={ generateQrCode }
							disabledSubmit={ submitDisabled }
						/>
					</ThemedBlock>

					{ content }
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const QrRow = ({ qrCode, details = false, refetch }) => {

	const _buildings        = useSelector( state => {
		return state.data[dataConstants.BUILDINGS];
	} );
	const _floors           = useSelector( state => {
		return state.data[dataConstants.FLOORS];
	} );
	const _rooms            = useSelector( state => {
		return state.data[dataConstants.ROOMS];
	} );
	const _timeslotKinds    = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	const _timeslotGroups = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_GROUPS];
	} );

	const [ showQrCodeModal, setShowQrCodeModal ] = useState( false );

	const onPressOpenQrCode = () => {
		setShowQrCodeModal( true );
	}

	const onPressRemove = ( callback ) => {
		new GraphqlBuilder( { processVariables: false })
			.addQuery( 'mutation_qrode_update', MutationManagementQrCodeUpdate, {
				guid: qrCode.guid,
				active: qrCode.active === 'no' ? 'yes' : 'no'
			})
			.setResultPath( ['mutation', 'mutation_qrode_update'], {} )
			.setOnStart( callback.bind( this, FormStatus.LOADING ) )
			.setOnError( callback.bind( this, FormStatus.ERROR ) )
			.setOnSuccess( ( result ) => {
				refetch();
				callback( FormStatus.SUCCESS );
			})
			.execute()
	}

	const onPressDownloadPDF = () => {
		const type = 'a4';
		const url = configClient.url() + `/connection/rest/pdf/generate/type/${type}/guid/${ qrCode.guid }`;

		openUrl( url, '_blank' );
	}

	const data = JSON.parse( qrCode.data );

	const text = [];
	let warning = null;
	_.forEach( data, ( dataValue, dataKey ) => {
		let label = null;
		let value = null;

		switch( dataKey ) {
			case 'building':
				label = i18n.t( 'management:form.building.title' );

				const building = _.get( _buildings, [ dataValue ], {} );
				value = _.get( building, [ 'name' ], '' );

				if( building.active === constantsActive.NO ) {
					warning = i18n.t('management:pages.qrcodes.index.warning_inactive' );
				}
				break;

			case 'floor':
				label = i18n.t( 'management:form.floor.title' );
				value = _.get( _floors, [ dataValue, 'name' ], '' );
				break;

			case 'room':
				label = i18n.t( 'management:form.room.title' );
				value = _.get( _rooms, [ dataValue, 'name' ], '' );
				break;

			case 'previewTimeslots':
				label = i18n.t( 'management:form.preview_timeslots.title' );
				value = i18n.t( `basic.${dataValue}` );
				break;

			case 'timeslotGroup':
				label = i18n.t( 'management:form.timeslot_group.title' );
				value = _timeslotGroups[ dataValue ].name;
				break;

			case 'timeslotKind':
				label = i18n.t( 'management:form.timeslot_kinds.title' );

				const timeslotKinds = [];
				_.forEach( dataValue, ( timeslotKindGuid ) => {
					timeslotKinds.push(  _.get( _.find( _timeslotKinds, { guid: timeslotKindGuid } ), 'name', '?' ) );
				});

				value = HelperArray.naturalJoin( timeslotKinds )
				break;
		}

		if( label !== null || value !== null ){
			text.push(
				<Text>{ label }: { value }</Text>
			);
		}
	});

	if( qrCode.active === constantsActive.NO ) {
		warning = i18n.t('management:pages.qrcodes.index.warning')
	}

	if( warning !== null ) {
		text.push(
			<Text style={ styles.textWarning }>{ warning }</Text>
		);
	}

	return (
		<VStack>
			<View style={styles.viewFlexDirectionRow}>
				<View style={styles.viewFlex3}>
					<ThemedPressable
						onPress={ onPressOpenQrCode }>

						<ThemedQrCode
							key={ HelperString.hash( 'qrcode', qrCode ) }
							value={ `mod:${qrCode.guid}` }
							size={ 100 }
							color={ !showQrCodeModal ? colorList.BLACK.primary : colorList.WHITE.primary }
							backgroundColor={ colorList.WHITE.primary}
						/>
					</ThemedPressable>
				</View>

				<View style={styles.viewFlex7}>
					{ text }

					{ details && (
						<Text style={ styles.textMarginTop23Opacity02 }>
							{`qrcode:${qrCode.guid}`}
						</Text>
					)}
				</View>

				<View style={{ flex: undefined }}>
					<Button
						onPress={ onPressDownloadPDF }>

						{ i18n.t(`management:pages.qrcodes.index.download_pdf_button`) }
					</Button>

					<QrPopover
						qrCode={ qrCode }
						onRemove={ onPressRemove }
					/>
				</View>
			</View>

			<ThemedModal
				visible={ showQrCodeModal }
				setVisible={ setShowQrCodeModal.bind( this, false ) }>

				<View
					style={ styles.qrModalView }>

					<ThemedQrCode
						key={ HelperString.hash( 'qrcode', 'modal' ) }
						value={ `mod:${qrCode.guid}` }
						size={ 400 }
					/>
				</View>
			</ThemedModal>
		</VStack>
	)
}

const QrPopover = ({ qrCode, onRemove }) => {

	const [ loading, setLoading ] = useState( false )
	const [ modalVisible, setModalVisible ] = useState( false )

	const onPressRemove = () => {
		onRemove( ( status ) => {
			switch( status ) {
				case FormStatus.LOADING:
					setLoading( true )
					break;

				default:
					setLoading( false )
					setModalVisible( false )
			}
		} )
	}

	const isActive = qrCode.active === constantsActive.YES

	return (
		<Popover
			anchor={ () => {
				return (
					<Button
						appearance={ 'ghost' }
						size="small"
						onPress={ setModalVisible.bind( this, true ) }
						accessoryRight={ props => {
							return (
								<Icon
									icon={ isActive ? IconSystemConstants.TRASH : IconSystemConstants.SAVE }
									{ ...props }
									size={ 12 }
								/>
							);
						}}>

						{ loading && (
							<Spinner
								size='small'
							/>
						)}

						{ i18n.t(`management:generic.${ isActive ? 'remove' : 'activate' }`) }
					</Button>
				);
			}}
			visible={ modalVisible }
			onBackdropPress={ setModalVisible.bind( this, false ) }>

			<Card>
				<Text
					style={ ThemedShared.paddingSmall }>

					{ i18n.t('alerts.are_you_sure.title') }
				</Text>
				<Button
					onPress={ onPressRemove.bind( this ) }>

					{ i18n.t('basic.yes') }
				</Button>
			</Card>
		</Popover>
	)
}

const styles = StyleSheet.create( {
	themedDividerMarginVertical12: {
		marginVertical: 12,
	},
	viewFlexDirectionRow: {
		flexDirection: 'row',
	},
	viewFlex3: {
		flex: 3,
	},
	viewFlex7: {
		flex: 7,
	},
	textMarginTop23Opacity02: {
		marginTop: 23,
		opacity: 0.2,
	},
	qrModalView: {
		width: '100%',
		height: '100%',
		alignItems: 'center',
		justifyContent: 'center',
		marginVertical: 24
	},

	textWarning: {
		color: colorList.RED.primary,
		fontSize: 10
	}
});

export default ManagementQrcodeIndexScene
